import { render, staticRenderFns } from "./InternationalWire.vue?vue&type=template&id=ef4f0fc6&scoped=true&"
import script from "./InternationalWire.vue?vue&type=script&lang=js&"
export * from "./InternationalWire.vue?vue&type=script&lang=js&"
import style0 from "./InternationalWire.vue?vue&type=style&index=0&id=ef4f0fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4f0fc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef4f0fc6')) {
      api.createRecord('ef4f0fc6', component.options)
    } else {
      api.reload('ef4f0fc6', component.options)
    }
    module.hot.accept("./InternationalWire.vue?vue&type=template&id=ef4f0fc6&scoped=true&", function () {
      api.rerender('ef4f0fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/forms/InternationalWire.vue"
export default component.exports